import {createContext, useContext} from 'react';
import type {AuthContextType} from '../types';

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

/** Хук для доступа к контексту авторизации. Бросает, если вне `<AuthProvider>`. */
export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
  return ctx;
};
